import { render } from "./BrandPortfolioTacosCell.vue?vue&type=template&id=ae999386&scoped=true"
import script from "./BrandPortfolioTacosCell.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioTacosCell.vue?vue&type=script&lang=js"

import "./BrandPortfolioTacosCell.vue?vue&type=style&index=0&id=ae999386&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae999386"]])

export default __exports__